import { useEffect } from "react";

export function useAppVersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/meta.json", {
          cache: "no-cache",
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
        });

        if (!response.ok) {
          console.warn("Unable to fetch meta.json");
          return;
        }

        const { version } = await response.json();
        const currentVersion = localStorage.getItem("appVersion");

        if (currentVersion && currentVersion !== version) {
          console.log("New version detected, reloading app...");

          // Clear cache and reload automatically
          if ("caches" in window) {
            caches.keys().then((names) => {
              names.forEach((name) => {
                caches.delete(name);
              });
            });
          }

          // Save new version before reload
          localStorage.setItem("appVersion", version);

          // Force reload with cache bust
          window.location.reload();
          return;
        }

        // Save version on first load
        localStorage.setItem("appVersion", version);
      } catch (error) {
        console.warn("Error checking version:", error);
      }
    };

    // Check only on mount
    checkVersion();
  }, []);
}
